import { ChangeDetectorRef, Component, computed, Signal } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';
import { DragDropModule } from 'primeng/dragdrop';
import { BaseComponentComponent } from '../../component/dashboard/base-component/base-component.component';
import { DragAndDropComponent } from "../../component/dashboard/drag-and-drop/drag-and-drop.component";
import { JsonPipe, NgForOf, NgIf } from '@angular/common';
import { GenericPanelComponent } from "../../component/generic/generic-panel/generic-panel.component";
import { CorePieChartComponent } from "../../component/generic/generic-pie-chart/generic-pie-chart.component";
import { GenericLineChartComponent } from "../../component/generic/generic-line-chart/generic-line-chart.component";
import { GenericBarChartComponent } from "../../component/generic/generic-bar-chart/generic-bar-chart.component";
import { TableModule } from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton';
import { TreeModule } from 'primeng/tree';
import { DasboardServiceService } from '../../services/data/dashboard/dasboard-service.service';
import { MainModel } from '../../model/MainModel';
import {toMoneyDisplay, toThousandsDisplay, colorShade, limitData} from "../../util/util";
import { Router } from '@angular/router';
import { isNull } from 'lodash';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [JsonPipe, TableModule, SkeletonModule, ChartModule, CardModule, DragAndDropComponent, NgForOf, NgIf, GenericPanelComponent, CorePieChartComponent, GenericLineChartComponent, GenericBarChartComponent, TreeModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {

    protected data:any = null;

    // ======================================================================
    protected raiseBySource:Array<any> = [];
    protected raiseBySourceTitles:Array<string> = [];
    protected raiseBySourceTotals:Array<number> = [];
    // ======================================================================
    protected raiseByEventTypeByCampaign:Array<any> = [];
    protected raiseByEventTypeByCampaignTitles:Array<string> = [];
    protected raiseByEventTypeByCampaignTotals:Array<number> = [];
    // ======================================================================
    protected topEventCodesByCampaign:Array<any> = [];

    protected isNull:any = isNull;
    protected toMoneyDisplay:any = toMoneyDisplay;
    protected toThousandsDisplay:any = toThousandsDisplay;

    constructor(
        private service: DasboardServiceService,
        protected model:MainModel,
        private cdr: ChangeDetectorRef,
        private router: Router
    ){

    }

    selectedComponents: BaseComponentComponent[] = [];
    campById = new Map();
    eventByID = new Map();
    childCampaignById = new Map();
    requestingData:boolean = false;
    eventCodesByID = new Map();
    sourceByID = new Map();
    campaign:Signal<number> = computed(() => {
        this.data = null;
        return this.model.selectedCampaign()?.campaignId || 0;
    })

    getSpendChartOption(){
        return {
            cutout: '65%',
            plugins: {
                annotation: {
                    annotations: {
                        dLabel: {
                        type: 'doughnutLabel',
                        content: () => {
                            const rVals:Array<string> = [];
                            rVals.push(this.getTotalSpendPercent().toString() + "%");
                            return rVals;
                        },
                        font: [{size: 45, weight: 300, family: "'Lato'"}],
                        color: ['#B13529']
                        }
                    }
                },
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        color: '#000000',
                        font: {size: 14, family: "'Lato'"}
                    }
                }
            }
        }
    }

    getTotalSpendPercent():number {
        const totalRaised = this.data.totalRaiseByCampaign[0]?.total;
        const totalSpent = this.data.totalSpendByCampaign[0]?.total;
        const initial = (totalSpent/totalRaised);
        return Math.round(initial * 100);
    }
    
    totalSpendDonutChartOptions:any = this.getSpendChartOption();

    ngOnInit() {
        this.model.campaignNotifier.subscribe({
        next: data => {
            this.data = null;
            this.queryForData(this.model.selectedCampaign()?.campaignId || 0); 
            },
        })
        this.queryForData(this.model.selectedCampaign()?.campaignId || 0); 
    }

    formatTotal(amount:number){
        const value:number = Math.round(amount);
        if(value > 1000 && value < 1000000){
            return value.toLocaleString('en-US', {maximumFractionDigits:0}).split(",")[0] + "K";
        }
        if(value >= 1000000 && value < 1000000000){
            return value.toLocaleString('en-US', {maximumFractionDigits:0}).split(",")[0] + "M";
        }
        if(value >= 1000000000 && value < 1000000000000){
            return value.toLocaleString('en-US', {maximumFractionDigits:0}).split(",")[0] + "B";
        }
        if(value >= 1000000000000){
            return value.toLocaleString('en-US', {maximumFractionDigits:0}).split(",")[0] + "T";
        }
        return parseInt(value.toString()).toString();
    }


    shouldShowData(ref:any){
        return this.data !== null && !isNull(ref);
    }

    str(val:any){
        return val + "";
    }

    queryForData(campID:any){
        if(this.requestingData)return;
        if(campID){
            this.requestingData = true;                
            this.service.getDashboardData(campID).subscribe({
            next: (data: any) => {
                this.requestingData = false;
                if (data) {
                    this.raiseBySourceTitles = [];
                    this.raiseBySourceTotals = [];
                    this.raiseByEventTypeByCampaignTitles = [];
                    this.raiseByEventTypeByCampaignTotals = [];
                    this.totalSpendDonutChartOptions = {};
                    this.totalSpendDonutChartOptions = this.getSpendChartOption();

                    this.data = {...data};
                    
                    // convert lists to maps for easier access...
                    data.campaigns?.forEach(
                        (item:any) => {
                            this.campById.set( this.str(item.id), item.title);
                        }
                    );
                    data.childCampaigns?.forEach(
                        (item:any) => {
                            this.childCampaignById.set( this.str(item.id), item.title);
                        }
                    );
                    data.eventCodes?.forEach(
                        (item:any) => {
                            this.eventCodesByID.set( this.str(item.id), item.title );
                        }
                    );
                    data.eventTypes?.forEach(
                        (item:any) => {
                            this.eventByID.set( this.str(item.id), item );
                        }
                    );
                    data.sources?.forEach(
                        (item:any) => {
                            this.sourceByID.set( this.str(item.id), item);
                        }
                    );

                    
                    // BAR AND DONUT CHARTS ======================================================================

                    if(data.totalRaiseByChildCampaign?.length){
                        data.totalRaiseByChildCampaign.sort(
                            (a:any, b:any) => {
                                return b.total - a.total;
                            }
                        );
                        data.totalRaiseByChildCampaign.length = data.totalRaiseByChildCampaign.length > 3 ? 3 : data.totalRaiseByChildCampaign.length ;
                        data.totalRaiseByChildCampaign.forEach(
                            (itm:any) => {
                                itm.childCampaign = this.childCampaignById.get(itm.childCampaignId.toString())
                            }
                        );
                        console.debug(data.totalRaiseByChildCampaign);
                    } else {
                        data.totalRaiseByChildCampaign = [];
                    }

                    if(data.totalSpendByChildCampaign?.length){
                        data.totalSpendByChildCampaign.sort(
                            (a:any, b:any) => {
                                return b.total - a.total;
                            }
                        )
                        data.totalSpendByChildCampaign.length = data.totalSpendByChildCampaign.length > 3 ? 3 : data.totalSpendByChildCampaign.length ;
                        data.totalSpendByChildCampaign.forEach(
                            (itm:any) => {
                                itm.childCampaign = this.childCampaignById.get(itm.childCampaignId.toString())
                            }
                        );
                        console.debug(data.totalSpendByChildCampaign);
                    } else {
                        data.totalSpendByChildCampaign = [];
                    }

                    if(data.raiseBySourceByCampaign?.length){
                        const _raiseBySourceByCampaign = limitData(data.raiseBySourceByCampaign, "total", "sourceId");
                        // titles and totals -------------------------------------------------
                        this.raiseBySourceTitles = _raiseBySourceByCampaign.map(i => {
                            const v = this.sourceByID.get( this.str(i.title));
                            return v?.title || i.title
                            }
                        );
                        this.raiseBySourceTotals = _raiseBySourceByCampaign.map(i => i.total);
                    } else {
                        data.raiseBySourceByCampaign = [];
                    }

                    if(data.raiseByEventTypeByCampaign?.length){
                        const _raiseByEventTypeByCampaign = limitData(data.raiseByEventTypeByCampaign, "total", "eventTypeId", 4);
                        // titles and totals -------------------------------------------------
                        this.raiseByEventTypeByCampaignTitles = _raiseByEventTypeByCampaign?.map(i => {
                            const v = this.eventByID.get( this.str(i.title) );
                            return v?.title || i.title;
                            }
                        );
                        this.raiseByEventTypeByCampaignTotals = _raiseByEventTypeByCampaign.map(i => i.total)
                    } else {
                        this.raiseByEventTypeByCampaign = [];
                    }

                    if(data.topEventCodesByCampaign?.length){
                        // first make the map of labels...
                        data.topEventCodesByCampaign.sort(
                            (a:any, b:any) => {
                                return b.total - a.total;
                            }
                        );
                        data.topEventCodesByCampaign.length = data.topEventCodesByCampaign.length > 5 ? 5 : data.topEventCodesByCampaign.length ;
                        data.topEventCodesByCampaign?.forEach(
                            (item:any) => {
                                const title = this.eventCodesByID.get(item.eventId.toString());
                                console.debug(item.eventId, title)
                                item.campaign = title;
                            }
                        );
                    } else {
                        this.topEventCodesByCampaign = [];
                    }


                    // TABLED DATA ==================================================================================

                    if(data.spendByVendorByCampaign?.length){
                        const vendorsById:Map<string,string> = new Map();
                        data.vendors.forEach(
                            (item:any) => {
                                vendorsById.set( this.str(item.id), item.title)
                            }
                        );
                        this.data.spendByVendorByCampaign = data.spendByVendorByCampaign?.map((i:any) => {
                            return { ...i, title: vendorsById.get( this.str(i.vendorId) ) }
                            }
                        );
                    } else {
                        this.data.spendByVendorByCampaign = [];
                    }
                    
                    if(data.spendByGlaccountByCampaign?.length){
                        const spendById:Map<string,string> = new Map();
                        data.gl.forEach(
                            (item:any) => {
                                spendById.set( this.str(item.id), item.title)
                            }
                        );
                        this.data.spendByGlaccountByCampaign = data.spendByGlaccountByCampaign?.map((i:any) => {
                            return { ...i, title: spendById.get( this.str(i.glaccount) ) }
                            }
                        );
                    } else {
                        this.data.spendByGlaccountByCampaign = [];
                    }
                    this.cdr.detectChanges();
                }
            },
            error: (err) => {
                console.error('Error loading donation lookups:', err);
            }
            });
        } else {
            setTimeout(() => this.queryForData(this.model.selectedCampaign()?.campaignId), 2000);
        }
    }

    dragStart(component: BaseComponentComponent) {
        //this.draggedComponent = component;
    }

    drop() {
        // if (this.draggedComponent) {
        //     let draggedIndex = this.findIndex(this.draggedComponent);
        //     this.selectedComponents = [...(this.selectedComponents as BaseComponentComponent[]), this.draggedComponent];
        //     this.draggedComponent = null;
        // }
    }

    dragEnd() {
        //this.draggedComponent = null;
    }

    findIndex(component: BaseComponentComponent) {
        let index = -1;
        for (let i = 0; i < this.selectedComponents.length ; i++) {
            const c:BaseComponentComponent = this.selectedComponents[i];
            if (c.typeId === component.typeId) {
                index = i;
                break;
            }
        }
        return index;
    }
    
    protected components:Array<any> = [
        {
            "title": "Component One",
            "type": "CorePieChartComponent",
            "thumb":"/assets/component-1.png"
        },    
        {
            "title": "Component Two",
            "type": "RaiseByElectionFundComponent",
            "thumb":"/assets/component-2.png"
        },
    ]
    draggedComponent: Array<DragAndDropComponent> = this.components.map(
        i => new DragAndDropComponent()
    );

};